var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('VLayout',{staticClass:"mb-4",attrs:{"column":""}},[_c('div',{staticClass:"mx-0 main-width loader-attente"}),_c('span',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }